// Copyright (c) 2021 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import {
    getFamilyWeek, getReallocationSeqBuildWeek,
    getReallocationSeqRetInd, getReallocationSeqSpecialAcct,
    getReallocationSeqUnitCode, postFamilyWeeks, postSortingSequence
} from './repositories';
import {
    retailIndData, sortFieldName, specialAcctData, unitCodeData
} from './atpReallocationData';
import AtpReallocationTable from './atpReallocationTable';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';
import { withRouter } from 'react-router-dom';

class AtpReallocation extends Component {

    state = {
        familyWeekNum: [],
        srcfamilyWeekNum: [],
        retailInd: [],
        buildWeek: [],
        specialAcc: [],
        unitCode: [],
        srcretailInd: [],
        srcbuildWeek: [],
        srcspecialAcc: [],
        srcunitCode: []
    };

    componentDidMount = () => {

        this.getSortingSeq();
        this.getFamilyWeek();

    }

    handleSeqChange ( name, val ) {

        const newObj = this.getArrayCopy( this.state[name] );
        if ( newObj && newObj[0] ) {

            newObj[0].seqNumber = val.target.value;

            this.setState( {
                [name]: newObj
            } );

        }

    }

    handleDropdownChange ( index, val ) {

        const newValue = this.getArrayCopy( this.state.familyWeekNum );
        if ( newValue && newValue[index] ) {

            newValue[index].weekNumber = val;

            this.setState( {
                familyWeekNum: newValue
            } );

        }

    }

    handleOrderChange ( name, value, index ) {

        const arr = this.getArrayCopy( this.state[name] );

        // Initialize the array if empty
        if ( !arr || arr.length === 0 ) {

            this.setState( {
                [`${name}`]: [{ [sortFieldName( index )]: value }]
            } );
            return;

        }

        // Initialize arr[0] if it doesn't exist
        if ( !arr[0] ) {

            arr[0] = {};

        }

        arr[0][sortFieldName( index )] = value;
        this.setState( {
            [`${name}`]: arr
        } );

    }

    getSortingSeq () {

        this.props.increaseCounter();
        getReallocationSeqRetInd( ).then( response => {

            this.setState( {
                retailInd: response,
                srcretailInd: this.getArrayCopy( response )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getReallocationSeqBuildWeek( ).then( response => {

            this.setState( {
                buildWeek: response,
                srcbuildWeek: this.getArrayCopy( response )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getReallocationSeqSpecialAcct( ).then( response => {

            this.setState( {
                specialAcc: response,
                srcspecialAcc: this.getArrayCopy( response )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

        this.props.increaseCounter();
        getReallocationSeqUnitCode( ).then( response => {

            this.setState( {
                unitCode: response,
                srcunitCode: this.getArrayCopy( response )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    getFamilyWeek () {

        this.props.increaseCounter();
        getFamilyWeek( ).then( response => {

            this.setState( {
                srcfamilyWeekNum: response,
                familyWeekNum: this.getArrayCopy( response )
            } );
            this.props.decreaseCounter();

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    getArrayCopy = arr => arr.map( i => ( i ? { ...i } : i ) );

    resetSortingSeq = () => {

        this.getSortingSeq();

    }

    submitSortingSeq = () => {

        const {
            retailInd, buildWeek, specialAcc, unitCode
        } = this.state;

        // Check if all required data is loaded
        if ( !buildWeek[0] || !retailInd[0] || !specialAcc[0] || !unitCode[0] ) {

            return;

        }

        const payload = {};
        payload.buildseqNumber = buildWeek[0].seqNumber;
        Object.keys( retailInd[0] ).forEach( key => {

            payload[`retail${key}`] = retailInd[0][key];
            return key;

        } );
        Object.keys( specialAcc[0] ).forEach( key => {

            payload[`special${key}`] = specialAcc[0][key];
            return key;

        } );
        Object.keys( unitCode[0] ).forEach( key => {

            payload[`unit${key}`] = unitCode[0][key];
            return key;

        } );
        postSortingSequence( payload ).then( resp => {

            if ( resp ) {

                this.getSortingSeq();

            }

        } );

    }

    resetFamilyWeeks = () => {

        this.getFamilyWeek();

    }

    submitFamilyWeeks = () => {

        const { familyWeekNum } = this.state;
        postFamilyWeeks( familyWeekNum ).then( resp => {

            if ( resp ) {

                this.getFamilyWeek();

            }

        } );

    }

    render () {

        const {
            familyWeekNum, retailInd, buildWeek,
            specialAcc, unitCode
        } = this.state;
        const weekList = [];
        let j = 0;
        [...Array( 35 )].forEach( () => {

            weekList.push( {
                id: j,
                label: j
            } );
            j += 1;

        } );
        weekList.push( {
            id: '35+',
            label: '35+'
        } );

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                <header>
                    <h2 className="page-header">ATP Reallocation Parameters</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-reallocation-options">
                            <div className="atp-reallocation-header">REALLOCATION SORTING SEQUENCE</div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Type</th>
                                        <th>Build Week</th>
                                        <th>Retail Ind</th>
                                        <th>Special Acct</th>
                                        <th>Unit Code</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Sequence</td>
                                        <td> {buildWeek && buildWeek.length > 0 &&
                                        <input type="number" name="buildWeek" value={buildWeek[0].seqNumber} onChange={this.handleSeqChange.bind( this, 'buildWeek' )} />}
                                        </td>
                                        <td> {retailInd && retailInd.length > 0 &&
                                        <input type="number" name="retailInd" value={retailInd[0].seqNumber} onChange={this.handleSeqChange.bind( this, 'retailInd' )} />}
                                        </td>
                                        <td> {specialAcc && specialAcc.length > 0 &&
                                        <input type="number" name="specialAcc" value={specialAcc[0].seqNumber} onChange={this.handleSeqChange.bind( this, 'specialAcc' )} />}
                                        </td>
                                        <td> {unitCode && unitCode.length > 0 &&
                                        <input type="number" name="unitCode" value={unitCode[0].seqNumber} onChange={this.handleSeqChange.bind( this, 'unitCode' )} />}
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>Order</td>
                                        <td />
                                        <td>
                                            <AtpReallocationTable
                                                type={retailIndData}
                                                data={retailInd}
                                                name="retailInd"
                                                onChange={this.handleOrderChange.bind( this )}
                                            />
                                        </td>
                                        <td>
                                            <AtpReallocationTable
                                                type={specialAcctData}
                                                data={specialAcc}
                                                name="specialAcc"
                                                onChange={this.handleOrderChange.bind( this )}
                                            />
                                        </td>
                                        <td> <AtpReallocationTable
                                            type={unitCodeData}
                                            data={unitCode}
                                            name="unitCode"
                                            onChange={this.handleOrderChange.bind( this )}
                                        />
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                            <div>
                                <button className="primary-button" type="button" onClick={this.submitSortingSeq.bind( this )}>
                                    <span> Update Sorting Sequence </span>
                                </button>
                                <button className="" type="button" onClick={this.resetSortingSeq}>
                                    <span> Reset </span>
                                </button>

                            </div>
                        </div>
                        <div className="atp-reallocation-options">
                            <div className="atp-reallocation-header">REALLOCATION FAMILY WEEKS</div>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Family</th>
                                        <th>Number of Weeks</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {familyWeekNum.map( ( i, index ) => (
                                        <tr key={i.familyName}>
                                            <td>{i.familyName}</td>
                                            <td><OptionsDropDown
                                                className="atp-reallocation-weekdropdown"
                                                label=""
                                                isPlaceholderTranslated={true}
                                                onChange={
                                                    this.handleDropdownChange.bind( this, index )
                                                }
                                                optionDisplayAttributes={['label']}
                                                optionKey="id"
                                                options={weekList}
                                                selectedValue={i.weekNumber}
                                            />
                                            </td>
                                        </tr>
                                    ) )}
                                </tbody>
                            </table>
                            <div>
                                <button className="primary-button" type="button" onClick={this.submitFamilyWeeks.bind( this )}>
                                    <span> Update Family Weeks </span>
                                </button>
                                <button className="" type="button" onClick={this.resetFamilyWeeks}>
                                    <span> Reset </span>
                                </button>

                            </div>
                        </div>
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

AtpReallocation.displayName = 'AtpReallocation';
AtpReallocation.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( AtpReallocation ) );
